import { render, staticRenderFns } from "./orderForBaseStation.vue?vue&type=template&id=3afbe6de&scoped=true"
import script from "./orderForBaseStation.vue?vue&type=script&lang=js"
export * from "./orderForBaseStation.vue?vue&type=script&lang=js"
import style0 from "./orderForBaseStation.vue?vue&type=style&index=0&id=3afbe6de&prod&lang=scss"
import style1 from "./orderForBaseStation.vue?vue&type=style&index=1&id=3afbe6de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afbe6de",
  null
  
)

export default component.exports